export default "__VITE_PUBLIC_ASSET__10436802__"